import React from 'react';
//import { Link } from 'react-router-dom';
import { BsCurrencyDollar } from 'react-icons/bs';
import { customFormatter } from '../../utils/currencyUtils';
import { getDifferenceBetweenDates, getMonth } from '../../utils/dateFormat';

const Spend = ({ mls }) => {
    //console.log(mls?.spend);
    const currentColor = "#e46a76";
    const currentBg = "#fff4e5";
    return (
        <div>
            <div className="flex flex-wrap lg:flex-nowrap justify-center">
                <div className="bg-gray dark:text-gray-200 dark:bg-secondary-dark-bg h-44 rounded-xl wd-41 md:wd-41 p-8 pt-9 m-1" style={{ border: '1px solid #ebecf0' }}>
                    <div className="flex justify-between items-center">
                        <div>
                            <p className="text-xl font-bold">Statement Period: <span className="text-gray-500">{getMonth(new Date(mls?.cash_flow?.opening_date))} - {getMonth(new Date(mls?.cash_flow?.closing_date))}</span></p>
                            <p className="text-lg">First Day in Statement: <span className="text-gray-400">{mls?.cash_flow?.opening_date}</span></p>
                            <p className="text-lg">Last Day in Statement: <span className="text-gray-400">{mls?.cash_flow?.closing_date}</span></p>
                            <p className="text-lg"> Statement Duration: <span className="text-gray-400">{getDifferenceBetweenDates(mls?.cash_flow?.opening_date, mls?.cash_flow?.closing_date)}</span></p>
                        </div>
                        <button type="button" style={{ backgroundColor: currentColor }} className="text-2xl opacity-0.9 text-white hover:drop-shadow-xl rounded-full  p-4">
                            <BsCurrencyDollar />
                        </button>
                    </div>
                </div>
                {/* start cards one */}
                <div className="bg-white dark:text-gray-200 dark:bg-secondary-dark-bg h-44 rounded-xl w-full md:w-60 p-4 pt-9 m-1" style={{ border: '1px solid #ebecf0', width: '18rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(mls?.spend?.web_spend)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Average Recurring Expense</p>
                </div>
                {/* end cards one */}
                {/* start cards two */}
                <div className="bg-white dark:text-gray-200 dark:bg-secondary-dark-bg h-44 rounded-xl w-full md:w-60 p-4 pt-9 m-1" style={{ border: '1px solid #ebecf0', width: '18rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">No</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Recurring Expenses</p>
                </div>
            </div>
            {/* breakdown info cards */}
            <div className="flex m-3 flex-wrap gap-2 items-left">
                {/* start cards one */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(mls?.spend?.atm_spend)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Atm Spend</p>
                </div>
                {/* end cards one */}
                {/* start cards two */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(mls?.spend?.web_spend)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Web Spend</p>
                </div>
                {/* end cards two */}
                {/* start cards three */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(mls?.spend?.pos_spend)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Pos Spend</p>
                </div>
                {/* end cards three */}
                {/* start cards four */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(0)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Ussd Transactions</p>
                </div>
                {/* end cards four */}
                {/* start cards one */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(mls?.spend?.mobile_spend)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Mobile Spend</p>
                </div>
                {/* end cards one */}
                {/* start cards two */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(mls?.spend?.spend_on_transfer)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Spend On Transfers</p>
                </div>
                {/* end cards two */}
                {/* start cards three */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(0)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">International Transactions Spend</p>
                </div>
                {/* end cards three */}
                {/* start cards four */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(mls?.spend?.bills)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Bills</p>
                </div>
                {/* end cards four */}
                {/* start cards one */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(mls?.spend?.entertainment)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Entertainment</p>
                </div>
                {/* end cards one */}
                {/* start cards two */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(mls?.spend?.savings_investments)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Savings And Investments</p>
                </div>
                {/* end cards two */}
                {/* start cards three */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(0)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Gambling</p>
                </div>
                {/* end cards three */}
                {/* start cards four */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(0)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Airtime</p>
                </div>
                {/* end cards four */}
                {/* start cards one */}
                <div className="bg-white h-44 dark:text-gray-200 dark:bg-secondary-dark-bg w-full md:w-60 p-4 pt-9 rounded-2xl" style={{ border: '1px solid #ebecf0', width: '17.7rem' }}>
                    <button type="button" style={{ color: currentColor, backgroundColor: currentBg }} className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl">
                        <BsCurrencyDollar />
                    </button>
                    <p className="mt-3">
                        <span className="text-lg font-semibold">{customFormatter(mls?.spend?.bank_charges)}</span>
                    </p>
                    <p className="text-lg text-gray-400 mt-1">Bank Charges</p>
                </div>
                {/* end cards one */}
            </div>
        </div>
    )
}

export default Spend
